<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-50 md-size-50">
			<h4>{{translate(locale.allProduct)}}</h4>
		</div>
		<div class="md-layout-item md-medium-size-50 md-size-50 text-right">
			<md-button class="md-raised md-primary" @click="$router.push('/products_and_services/new')">{{translate(locale.newProduct)}}</md-button>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<md-card>
				<md-card-content>
					<loading v-if="!loaded" />
					<!-- <el-tabs v-model="tabName" v-if="loaded">
						<el-tab-pane label="My All Activities" name="first"></el-tab-pane>
						<el-tab-pane label="Create New Activity" name="second"></el-tab-pane>
					</el-tabs> -->
					<div v-if="loaded">
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-size-40">
								<md-field>
									<label>{{translate(locale.searchProduct)}}</label>
									<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-50 md-size-20">
								<md-field>
									<label>{{translate(locale.status)}}</label>
									<md-select :placeholder="translate(locale.statusAll)" v-model="search.status">
										<md-option value="">{{translate(locale.all)}}</md-option>
										<md-option value="1">{{translate(locale.active)}}</md-option>
										<md-option value="0">{{translate(locale.disabled)}}</md-option>
									</md-select>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-50 md-size-20">
								<md-field>
									<label>{{translate(locale.type)}}</label>
									<md-select :placeholder="translate(locale.typeAll)" v-model="search.type">
										<md-option value="">{{translate(locale.all)}}</md-option>
										<md-option value="1">{{translate(locale.product)}}</md-option>
										<md-option value="2">{{translate(locale.service)}}</md-option>
									</md-select>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-20">
								<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">{{translate(locale.search)}}</md-button>
							</div>
						</div>
						<md-table v-if="productList.length > 0">
							<md-table-row>
								<md-table-head></md-table-head>
								<md-table-head>{{translate(locale.thumbnail)}}</md-table-head>
								<md-table-head>{{translate(locale.title)}}</md-table-head>
								<md-table-head>{{translate(locale.category)}}</md-table-head>
								<md-table-head>{{translate(locale.price)}}</md-table-head>
								<md-table-head style="min-width: 200px;">{{translate(locale.lastUpdate)}}</md-table-head>
								<md-table-head>{{translate(locale.status)}}</md-table-head>
								<md-table-head>{{translate(locale.action)}}</md-table-head>
							</md-table-row>

							<md-table-row v-for="(product, index) in productList">
								<!-- <md-table-cell></md-table-cell> -->
								<md-table-cell>​{{ index + 1 }}</md-table-cell>
								<md-table-cell><img :src="config.cdn + 'images/' + product.image_cover_url" style="width: 100px"></md-table-cell>
								<md-table-cell><b>{{product.name}}</b><br>{{translate(product.product_type_name)}}</md-table-cell>
								<md-table-cell>
									<b>{{translate(product.product_category_name)}}</b> <br> {{translate(product.product_sub_category_name)}}
								</md-table-cell>
								<md-table-cell>
									<span v-if="product.product_price_type_id != 1"><b>{{config.moneylify(product.price)}}</b><br>({{translate(product.product_price_type_name)}})</span>
									<span v-else><b>{{translate(locale.notAvailable)}}</b></span>
								</md-table-cell>
								<md-table-cell><b>{{ product.first_name }} {{ product.last_name }}</b><br>{{ translate(config.datelify(product.updated_date)) }}</md-table-cell>
								<md-table-cell>
									<span class="late" v-if="product.status == 0">{{translate(locale.disabled)}}</span>
									<span class="green" v-if="product.status == 1">{{translate(locale.active)}}</span>
								</md-table-cell>
								<md-table-cell>
									<a :href="config.redirect_url + '/products-and-services/' + product.hash" target="_blank">
										<md-button class="md-just-icon md-simple md-primary" v-if="product.status == 1">
											<md-icon>visibility</md-icon>
											<md-tooltip md-direction="top">{{translate(locale.viewThis)}}</md-tooltip>
										</md-button>
									</a>
									<md-button class="md-just-icon md-simple md-primary" v-if="product.status == 0" @click="onEnable(product.hash)">
										<md-icon>check_circle</md-icon>
										<md-tooltip md-direction="top">{{translate(locale.enableThis)}}</md-tooltip>
									</md-button>
									<router-link :to="'products_and_services/edit/' + product.hash">
										<md-button class="md-just-icon md-simple md-info">
											<md-icon>edit</md-icon>
											<md-tooltip md-direction="top">{{translate(locale.editThis)}}</md-tooltip>
										</md-button>
									</router-link>

									<md-button class="md-just-icon md-simple md-warn" v-if="product.status == 1" @click="onDisable(product.hash)">
										<md-icon>hide_source</md-icon>
										<md-tooltip md-direction="top">{{translate(locale.disableThis)}}</md-tooltip>
									</md-button>
									
									<md-button class="md-just-icon md-simple md-danger" v-if="product.status == 0" @click="onDelete(product.hash)">
										<md-icon>delete</md-icon>
										<md-tooltip md-direction="top">{{translate(locale.deleteThis)}}</md-tooltip>
									</md-button>
								</md-table-cell>
							</md-table-row>
						</md-table>
						<h5 class="text-center" v-if="productList.length == 0 && loaded == true">{{translate(locale.noProduct)}}</h5>
						<div class="places-buttons text-center" v-if="loadMore">
							<md-button class="md-primary" @click="searchHandler(true)">{{translate(locale.showMore)}}</md-button>
						</div>
					</div>

					<md-dialog-confirm :md-active.sync="deleteDialogActive" :md-title="translate(locale.deleteProduct)" :md-confirm-text="translate(locale.delete)"
						:md-cancel-text="translate(locale.cancel)" @md-cancel="onCancel" @md-confirm="onDelete" />
						<md-dialog-confirm :md-active.sync="disableDialogActive" :md-title="translate(locale.disableProduct)" :md-confirm-text="translate(locale.disable)"
						:md-cancel-text="translate(locale.cancel)" @md-cancel="onCancel" @md-confirm="onDisable" />
				</md-card-content>
			</md-card>
		</div>
	</div>
		
	</div>

</template>

<script>

	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
		},

		data() {
			return {
				loaded: false,
				deleteDialogActive: false, deleteSelected: '',
				disableDialogActive: false, disableSelected: '',
				search: { text: "", status: "", type: "" },
				loadMore: false,
				productList: []
			}
		},
		methods: {
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/profile/product/search", {
					text: this.search.text,
					status: this.search.status,
					type: this.search.type,
					offset: more ? this.productList.length : 0
				}).then(data => {
					this.loaded = true;
					if (data.body.data.length == 100) this.loadMore = true;
					else this.loadMore = false;
					this.productList = more ? this.productList.concat(data.body.data) : data.body.data;
				})

			},

			showDeleteAction(id) {
				this.deleteSelected = id
				this.deleteDialogActive = true
			},
			onDelete(hash) {
				if(this.deleteSelected == "") {
					this.deleteDialogActive = true;
					this.deleteSelected = hash;
					return;
				}
				this.$http.post(this.config.api + "/profile/product/delete", {
					hash: this.deleteSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have deleted the product successfully.",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onDisable(hash) {

				if(this.disableSelected == "") {
					this.disableDialogActive = true;
					this.disableSelected = hash;
					return;
				}
				this.$http.post(this.config.api + "/profile/product/disable", {
					hash: this.disableSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have disabled the product successfully.",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},

			onEnable(hash) {

				this.$http.post(this.config.api + "/profile/product/enable", {
					hash: hash
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have enabled the product successfully.",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onCancel() {
				this.deleteSelected = ""
				this.disableSelected = ""
				this.deleteDialogActive = false
				this.disableDialogActive = false
			},	
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Products/View.vue